var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.2389579 7.9999089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#918f90",
    strokeWidth: 0.352778,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.06257 2.70064l-.09-.38629c-.0381-.16334-.21237-.29704-.3877-.29704H.65409c-.17533 0-.34995.1337-.3877.29704l-.09.38629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4617 2.01731L3.11903 3.66125l-1.4217-1.64394z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26212 7.8235L4.30997.17739c0-.0007-.0007-.001-.001-.001h-2.4578c-.00035 0-.001.00035-.001.001L.9774 7.8235M5.25906.81769l-.0818-.32773c-.0423-.1704-.22014-.30974-.39512-.30974H1.45016c-.17498 0-.35243.13934-.39511.30974l-.0815.32773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94194 5.76049L3.11949 7.82353 1.29704 5.76049l1.82245-2.14242z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.f760b2da.svg";
export { ForwardRef as ReactComponent };